import { Button, Dropdown, Flex, Tag } from 'antd'
import React from 'react'
import { Icon } from '~/features/shared/icons'
import { DataFilters } from '../hooks/useData'

type Props = {
  countTickets: number
  filters: DataFilters
  onChangeFilters: (filters: DataFilters) => void
}

export const Toolbar: React.FC<Props> = ({
  countTickets = 0,
  filters,
  onChangeFilters,
}) => {
  const isClosed = filters.status.includes('CLOSED')

  const onMenuClick = ({ key }) => {
    onChangeFilters({ ...filters, status: [key] })
  }

  return (
    <Flex gap={8} align="center">
      {/* <Typography.Text type="secondary">Status</Typography.Text> */}

      <div>
        <Dropdown
          menu={{
            items: [
              {
                key: 'OPEN',
                label: 'Open',
              },
              {
                key: 'CLOSED',
                label: 'Closed',
              },
            ],
            onClick: onMenuClick,
          }}
        >
          <Button
            type="text"
            icon={<Icon name="chevron-down" />}
            iconPosition="end"
          >
            {isClosed && (
              <Tag className="m-0" color="green-inverse">
                CLOSED
              </Tag>
            )}
            {!isClosed && (
              <Tag className="m-0" color="warning">
                OPEN
              </Tag>
            )}
          </Button>
        </Dropdown>
      </div>

      <Flex align="center">
        <Tag>{countTickets} results</Tag>
      </Flex>
    </Flex>
  )
}
